import Head from 'next/head';
import { NextSeo, type NextSeoProps } from 'next-seo';
import { memo, useMemo } from 'react';

import { usePublicWorkspace } from '~/components/PublicWorkspaceProvider';
import { I18n } from '~/constants/I18n';

export type PublicSeoPageTitleProps = NextSeoProps;

export const PublicPageSeoTitle = memo(({ title, ...restOfProps }: PublicSeoPageTitleProps) => {
  const { workspaceName } = usePublicWorkspace();

  const formattedTitle = useMemo(() => {
    const pageTitle = title?.trim();

    if (pageTitle) {
      return pageTitle;
    }

    const publicWorkspaceName = workspaceName?.trim();

    if (publicWorkspaceName) {
      return publicWorkspaceName;
    }

    return undefined;
  }, [title, workspaceName]);

  return (
    <>
      {/* A bare `<title>` so DefaultSeo's `%s | Air` template does not turn this into "Air | Air". */}
      {formattedTitle ? null : (
        <Head>
          <title key="title">{I18n.basePageShortTitle}</title>
        </Head>
      )}
      <NextSeo nofollow noindex title={formattedTitle} {...restOfProps} />
    </>
  );
});

PublicPageSeoTitle.displayName = 'PublicPageSeoTitle';
